import { render, staticRenderFns } from "./enterprisePartner.vue?vue&type=template&id=b1a5b5c6&"
import script from "./enterprisePartner.vue?vue&type=script&lang=js&"
export * from "./enterprisePartner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports